import { Fragment } from "react";

export default function CustomInput({
  type,
  name,
  labelText,
  placeholder,
  register,
  handleClick,
  inputIcon,
  imgAlt,
  showPasswordStatus,
  error,
  value,
  min,
  max,
  step,
}) {
  return (
    <Fragment>
      <label htmlFor={name} className="font-poppins text-gray-500 text-xs lg:text-sm">
        {labelText}
      </label>
      <p className="relative">
        <input
          type={type}
          min={min}
          max={max}
          step={step}
          name={name}
          placeholder={placeholder}
          className={`w-full p-2 lg:p-3 border-bw rounded-md text-xs lg:text-sm font-figtree placeholder:text-xs lg:placeholder:text-sm placeholder:font-figtree placeholder:text-black focus-input
            ${error ? "border-red-500" : "border-lg4"}
          }`}
          {...register}
          value={value}
        />
        {handleClick ? (
          <img
            src={inputIcon}
            className={`absolute right-3 top-4 cursor-pointer ${
              showPasswordStatus ? "w-4 h-4" : "w-5 h-5"
            }`}
            alt={imgAlt}
            onClick={handleClick}
          />
        ) : (
          <img
            src={inputIcon}
            className="absolute right-3 top-5"
            alt={imgAlt}
          />
        )}
      </p>
      <p
        className={`text-red-500 font-figtree text-xs h-4 ${
          error ? "visible" : "invisible"
        }`}
      >
        {error?.message}
      </p>
    </Fragment>
  );
}
